/**
 * Created by Florin David on 21/04/2017.
 */

interface Translations {
  [key: string]: {
    locale: string
    messages: {
      [key: string]: string
    }
  }
}

const translations: Translations = {
  en: {
    locale: 'en',
    messages: {
      error: 'Error',
      updating: 'Updating...',
      update: 'Update',
      newVersionAvailable: 'A new version is available',
      password: 'Password',
      username: 'Username',
      chooseRole: 'Choose Role',
      chooseOrganization: 'Choose Organization',
      signIn: 'Sign In',
      sessionExpired: 'Session Expired.',
      sessionExpiredMessage: 'Enter credentials for reconnection.',
      wrongCredentials: 'The username or password you entered is incorrect',
      apiCommunicationErrorMessage: 'There is no network access.',
      connectionErrorMessage:
        'There is no network access, please check your internet connection.',
      noData: 'No data',
    },
  },
}

export default translations
